import {OfferType} from "../../offer/types/OfferType";
import {commercialSearchFilters} from "./commercial_search_filters";
import {flatSearchFilters} from "./flat_search_filters";
import {houseSearchFilters} from "./house_search_filters";
import {mixedSearchFilters} from "./mixed_search_filters";
import {notificationFilters} from "./notification_filters";

export const searchFilters = {
    [OfferType.FLAT]: flatSearchFilters,
    [OfferType.HOUSE]: houseSearchFilters,
    [OfferType.COMMERCIAL]: commercialSearchFilters,
    [OfferType.MODULAR_HOUSE]: mixedSearchFilters,
    notification: notificationFilters,
    default: mixedSearchFilters
};
import {OfferType} from "../../offer/types/OfferType";
import {commercialSearchFilters} from "./commercial_search_filters";
import {flatSearchFilters} from "./flat_search_filters";
import {houseSearchFilters} from "./house_search_filters";
import {mixedSearchFilters} from "./mixed_search_filters";
import {notificationFilters} from "./notification_filters";

export const searchFilters = {
    [OfferType.FLAT]: flatSearchFilters,
    [OfferType.HOUSE]: houseSearchFilters,
    [OfferType.COMMERCIAL]: commercialSearchFilters,
    [OfferType.MODULAR_HOUSE]: mixedSearchFilters,
    notification: notificationFilters,
    default: mixedSearchFilters
};
